import { getStep } from '../registry';
import { TourState } from '../types';

/**
 * Applied on rehydration: if a tour's current step declares `restoreTo`, advance past it so
 * a reload never lands the user on a transient/modal step (e.g. the feedback modal -> End2).
 * Returns a new map; does not mutate the input.
 */
const applyRestoreOnRehydrate = (tours: Record<string, TourState>): Record<string, TourState> => {
  const next: Record<string, TourState> = {};
  Object.entries(tours ?? {}).forEach(([tourId, tour]) => {
    // Legacy/partially-migrated entries may lack these fields, so default them rather than spreading
    // or incrementing undefined (matches the `?.` guard already used for stepHistory below).
    const stepHistory = tour.stepHistory ?? [];
    const currentStepId = stepHistory[stepHistory.length - 1];
    const step = currentStepId ? getStep(tourId, currentStepId) : undefined;

    if (step?.restoreCompletes && !tour.completedAt) {
      // Terminal transient step (the feedback modal): a reload ends the tour rather than
      // stranding the user inside the modal.
      const now = new Date().toISOString();
      next[tourId] = { ...tour, completedAt: now, lastCompletedAt: now, completedTimes: (tour.completedTimes ?? 0) + 1 };
      return;
    }

    const { restoreTo } = step ?? {};
    next[tourId] = restoreTo && restoreTo !== currentStepId ? { ...tour, stepHistory: [...stepHistory, restoreTo] } : tour;
  });
  return next;
};

export default applyRestoreOnRehydrate;
